import { render } from "./PageGalleries.vue?vue&type=template&id=862584f4"
import script from "./PageGalleries.vue?vue&type=script&lang=js"
export * from "./PageGalleries.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__